// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.row_YWK3j {
    width: 100%;
    padding: 8px 8px 8px 16px;
    gap: 8px !important;
}`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/details/pairing/PairingDetailRenderer.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,yBAAyB;IACzB,mBAAmB;AACvB","sourcesContent":[".row {\n    width: 100%;\n    padding: 8px 8px 8px 16px;\n    gap: 8px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"row": `row_YWK3j`
};
export default ___CSS_LOADER_EXPORT___;
